<div class="flex min-h-svh flex-col">
  <app-header />
  <main class="wrapper grow bg-body">
    <router-outlet />
  </main>
</div>
<app-footer />
